<template>
  <div class="index">
		<Header class="header" @open-modal="handleOpenModal"></Header>
      <div class="top wow fadeInDown">
          <!-- <div class="header">
              <div class="left wow fadeInDown" data-wow-duration="2s">
								<img src="../../assets/bannerlogo.png"/>
							</div>
          </div> -->
          <div class="content">
              <div class="title1  wow bounceInLeft"  data-wow-duration="2s">TAROKO</div>
              <div class="content_font wow fadeInUp" data-wow-duration="2s">Use AI technology to transform and reshape business and provide users </div>
              <div class="content_font wow fadeInUp" data-wow-duration="2s">with better information, products and services. </div>
          </div>
      </div>
      <div class="about">
          <div class="content">
            <!-- <img class="point wow fadeInRight" src="../../assets/combinedShape.png"/> -->
            <div class="left  wow fadeInDown">
                <!-- <div class="title wow fadeInLeft" data-wow-duration="1.5s">QCARD</div> -->
                <div class="title1 wow fadeInLeft" data-wow-duration="2s">ABOUT US</div>
                <div class="wow fadeInLeft" data-wow-duration="2.5s">TAROKO S.A. DE C.V. is a technology-based company, focusing on the in-depth research and development of big data, computer vision, machine learning, natural language processing and other related technologies through software-as-a-service solutions, helping enterprises achieve intelligent digital transformation, anti-fraud strategy design and process automation deployment, focusing on the service industry, and providing them with digital transformation, anti-fraud and process automation solutions.</div>
            </div>
            <div class="right wow fadeInRight" data-wow-duration="2s" data-wow-delay="0.8s"><img src="../../assets/aboutUs.png"/></div>
          </div>
      </div>
      <div class="service">
          <div class="header">
              <div class="left">
                <!-- <div class="title wow fadeInLeft" data-wow-duration="2s">QCARD</div> -->
                <div class="title1 wow fadeInUp" data-wow-duration="2s">Service Introduction</div>
              </div>
              <div class="right wow fadeInRight" data-wow-duration="2.5s">
                  <div>We provide customers with one-stop solutions by integrating data, technology,</div>
                  <div> ethical compliance and ideological creativity in compliance.</div>
              </div>
          </div>
          <div class="introduction">
             <!-- <div class="left">
                  <div class="wow fadeInLeft" data-wow-duration="2s" style="margin-top:0"><img src="../../assets/introduceIcon1.png"/></div>
                  <div class="wow fadeInLeft" data-wow-duration="2s"><img src="../../assets/introduceIcon2.png"/></div>
                  <div class="wow fadeInLeft" data-wow-duration="2s"><img src="../../assets/introduceIcon1.png"/></div>
                  <div class="wow fadeInLeft" data-wow-duration="2s"><img src="../../assets/introduceIcon2.png"/></div>
                  <div class="wow fadeInLeft" data-wow-duration="2s"><img src="../../assets/introduceIcon1.png"/></div>
                  <div class="wow fadeInLeft" data-wow-duration="2s" style="margin-bottom:0"><img src="../../assets/introduceIcon2.png"/></div>
              </div> -->
              <div class="right">
                  <!-- <img class="point wow fadeInRight" src="../../assets/combinedShape.png"/> -->
									<div class="right_row">
										<div class="wow fadeInRight item" data-wow-duration="2s">
											<div class="item_img">
												<img src="../../assets/Service1.png"/>
											</div>
											<div class="item_text">Support "collection and labeling" one-stop service - full process, easy to expand.</div>
										</div>
										<div class="wow fadeInRight item" data-wow-duration="2s">
											<div class="item_img">
												<img src="../../assets/Service2.png"/>
											</div>
											<div class="item_text">Support the acquisition and labeling of image, voice, language, video and other morphological data.</div>
										</div>
										<div class="wow fadeInRight item" data-wow-duration="2s">
											<div class="item_img">
												<img src="../../assets/Service3.png"/>
											</div>
											<div class="item_text">Provide privatization and customized deployment of data annotation system.</div>
											</div>
									</div>
									<div class="right_row">
										<div class="wow fadeInRight item" data-wow-duration="2s">
											<div class="item_img">
												<img src="../../assets/Service4.png"/>
											</div>
											<div class="item_text">Triple check of data inspection to ensure that data processing achieves more than 99.8% of the qualified rate.</div>											
											</div>
										<div class="wow fadeInRight item" data-wow-duration="2s">
											<div class="item_img">
												<img src="../../assets/Service5.png"/>
											</div>
											<div class="item_text">Establish a standardized process, have a complete personnel and management training mechanism, and ensure the professional ability of the data management team.</div>											
											</div>											
										<div class="wow fadeInRight item" data-wow-duration="2s" style="margin:0">
									<div class="item_img">
										<img src="../../assets/Service6.png"/>
									</div>
									<div class="item_text">Provide localized data processing strategy, high cost performance, safe and professional data management.</div>				</div>
                  </div>
                  
                  <!-- <div class="priceBtn">
                      <div class="wow fadeInRight btn" @click="openChile" data-wow-duration="2s" >
                          <img src="../../assets/chile.png"/>CHILE
                      </div>
                      <div style="width:60px"></div>
                      <div class="wow fadeInRight btn" @click="openPeru" data-wow-duration="2s" >
                          <img src="../../assets/peru.png"/>PERU
                      </div>
                  </div> -->
              </div>
          </div>
      </div>
      <div class="our">
				<div class="title wow fadeInUp" data-wow-duration="2s">
				    <div class="title_font">OUR CULTURE</div>
				</div>
        <div class="content">
					
            <div class="item wow fadeInUp" data-wow-duration="2s">
							<img src="../../assets/our1.png"/>
                <div>CUSTOMER <br/>ORIENTED</div>
            </div>
            <div class="item wow fadeInUp" data-wow-duration="3s" data-wow-delay="0.5s">
                <div>EVIDENCE <br/>ORIENTED</div>
                <img src="../../assets/our2.png"/>
            </div>
            <div class="item wow fadeInUp" data-wow-duration="4s" data-wow-delay="1s">
                <div>PEOPLE <br/>ORIENTED</div>
                <img src="../../assets/our3.png"/>
            </div>
            
        </div>
      </div>
      <div class="footer">
          <div class="content">
            <!-- <div>QCARD</div> -->
            <div class="title">Sense of worth</div>
            <div class="sence">
                <div class="item wow fadeInUp" data-wow-duration="4s">
                    <img src="../../assets/footer1.png"/>
                    <div class="item_title">INNOVATION</div>
                    <div class="item_content">Start business from beginning to the end ; Optimistic view of change; Try new solutions to surprise customers.</div>
                </div>
                <div class="item wow fadeInUp" data-wow-duration="4s">
                    <img src="../../assets/footer2.png"/>
                    <div class="item_title">BE REALISTIC</div>
                    <div class="item_content">Insist on doing the right thing;  Because of sincerity,  it is simple;  Based on the facts, do what you say.</div>
                </div>
                <div class="item wow fadeInUp" data-wow-duration="4s">
                    <img src="../../assets/footer3.png"/>
                    <div class="item_title">REFINEMENT</div>
                    <div class="item_content">High quality, starts from me; Think more and do more; Make small things beautiful and details perfect.</div>
                </div>
            </div>
          </div>
      </div>
			<div class="copyright">
				<div class="title wow fadeInUp" data-wow-duration="4s">TAROKO</div>
				<div class="email wow fadeInUp" data-wow-duration="4s">RFC: TAR210322587</div>
				<div class="time wow fadeInUp" data-wow-duration="4s">Email: tarokoservice@outlook.com</div>
				<div class="time wow fadeInUp" data-wow-duration="4s">Business hours : 9:00 a.m to 6:00 p.m</div>
				<div class="time wow fadeInUp" @click="goUserAgreement" style="cursor: pointer;" data-wow-duration="4s">Service Terms and Conditions</div>
				<div class="time wow fadeInUp" @click="goPrivacyPolicy"  style="cursor: pointer;" data-wow-duration="4s">Privacy Policy</div>
			</div>
			
			
			
        <Modal v-model="chileModal" width="80%" class-name="vertical-center-modal">
            <template #header>
                <p class="modalTitle">
                    CHILE SERVICES
                </p>
            </template>
            <div class="modalBody">
                <div class="title">Price</div>
                <div>
                    <RadioGroup v-model="type" type="button" size="large">
                        <Radio label="1">25,000 CLP / Month</Radio>
                        <Radio label="2">65,000 CLP / Quater</Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px">
                    <RadioGroup v-model="type" type="button" size="large">
                        <Radio label="3">125,000 CLP / 6 months</Radio>
                        <Radio label="4">240,000 CLP/ Year</Radio>
                    </RadioGroup>
                </div>
                <div class="title" style="margin-top:16px">Payment Method</div>
                <div style="margin-top:16px" class="methodItem icon1">
                    <RadioGroup class="icon1" @on-change="openTips" v-model="method" type="button" size="large" style="margin-top:16px">
                        <Radio label="1">
                            <span>Bank Transfer</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px" class="methodItem icon2">
                    <RadioGroup v-model="method" @on-change="openTips" type="button" size="large">
                        <Radio label="2">
                            <span>Debit Card</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px" class="methodItem icon3">
                    <RadioGroup v-model="method" @on-change="openTips" type="button" size="large">
                        <Radio label="3">
                            <span>Credit Card</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px" class="methodItem icon4">
                    <RadioGroup v-model="method" @on-change="openTips" type="button" size="large" style="margin-top:16px">
                        <Radio label="4">
                            <span>Cash Payment</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
            </div>
            <template #footer>
                <Icon type="ios-alert-outline" />
                <span>Note: want to know more about price please contact our customer service staff</span>
            </template>
        </Modal>
        <Modal v-model="peruModal" width="80%" class-name="vertical-center-modal">
            <template #header>
                <p class="modalTitle">
                    PERU SERVICES
                </p>
            </template>
            <div class="modalBody">
                <div class="title">Price</div>
                <div>
                    <RadioGroup v-model="peruType" type="button" size="large">
                        <Radio label="1">100 PEN /Month</Radio>
                        <Radio label="2">270 PEN / Quater</Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px">
                    <RadioGroup v-model="peruType" type="button" size="large">
                        <Radio label="3">500 PEN / 6 months</Radio>
                        <Radio label="4">950 PEN/ Year</Radio>
                    </RadioGroup>
                </div>
                <div class="title" style="margin-top:16px">Payment Method</div>
                <div style="margin-top:16px" class="methodItem icon1">
                    <RadioGroup @on-change="openTips" v-model="peruMethod" type="button" size="large" style="margin-top:16px">
                        <Radio label="1">
                            <span>Bank Transfer</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px" class="methodItem icon2">
                    <RadioGroup v-model="peruMethod" @on-change="openTips" type="button" size="large">
                        <Radio label="2">
                            <span>Debit Card</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px" class="methodItem icon3">
                    <RadioGroup v-model="peruMethod" @on-change="openTips" type="button" size="large">
                        <Radio label="3">
                            <span>Credit Card</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px" class="methodItem icon4">
                    <RadioGroup v-model="peruMethod" @on-change="openTips" type="button" size="large" style="margin-top:16px">
                        <Radio label="4">
                            <span>Cash Payment</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
            </div>
            <template #footer>
                <Icon type="ios-alert-outline" />
                <span>Note: want to know more about price please contact our customer service staff</span>
            </template>
        </Modal>
				<!-- 选择弹窗 -->
				<Modal v-model="chooseModalOpen" width="1000px" class-name="chooseModal" footer-hide>
				    <div>
							<div class="title_row">
								<div class="title_1">Choose your subscription</div>
								<div class="title_2">Feel free to choose a subscription that best meets your requirement</div>
							</div>
							<div class="fox_row">
								<div class="fox1">
									<div class="content_1">Billed Monthly</div>
									<div class="content_2">250</div>
									<div class="content_3">MXN</div>
									<div class="content_4">Auto-renewal, cancel at anytime</div>
									<div class="content_5" @click="buyClick(250)">Buy Now</div>
								</div>
								<div class="fox2">
									<div class="content_1">Billed Quarterly</div>
									<div class="content_2">600</div>
									<div class="content_3">MXN</div>
									<div class="content_4">Auto-renewal, cancel at anytime</div>
									<div class="content_5" @click="buyClick(600)">Buy Now</div>
								</div>
								<div class="fox3">
									<div class="content_1">Billed Yearly</div>
									<div class="content_2">2100</div>
									<div class="content_3">MXN</div>
									<div class="content_4">Auto-renewal, cancel at anytime</div>
									<div class="content_5" @click="buyClick(2100)">Buy Now</div>
								</div>
							</div>
						</div>
				</Modal>
				
				<!-- 选择弹窗 -->
				<Modal v-model="chooseModalOpen" width="1160px" class-name="chooseModal" footer-hide>
				    <div>
							<div class="title_row">
								<div class="title_1">Choose your subscription</div>
								<div class="title_2">Feel free to choose a subscription that best meets your requirement</div>
							</div>
							<div class="fox_row">
								<div class="fox1">
									<div class="content_0">Basic</div>
									<div class="content_1">Basic Plan</div>
									<div class="content_2">Ideal for freelancers and research teams requiring high-quality, foundational data labeling.</div>
									<div class="content_3_row">
										<div class="content_3">
											<div class="content_3_1"><div class="content_3_1_1"></div></div>
											<div class="content_3_2">
												<div class="content_3_2_1">Essential Annotation Tools:</div>
												<div class="content_3_2_2">Access to our secure cloud platform for high-precision image and text</div>
											</div>
										</div>
										
										<div class="content_3">
											<div class="content_3_1"><div class="content_3_1_1"></div></div>
											<div class="content_3_2">
												<div class="content_3_2_1">Guaranteed 95% Accuracy:</div>
												<div class="content_3_2_2">Standardized double-inspection process to ensure clean datasets for initial model training.</div>
											</div>
										</div>
										
										<div class="content_3">
											<div class="content_3_1"><div class="content_3_1_1"></div></div>
											<div class="content_3_2">
												<div class="content_3_2_1">Standard Processing:</div>
												<div class="content_3_2_2">Reliable 5-7 business day turnaround for medium-scale data batches and basic projects.</div>
											</div>
										</div>
									</div>
									
									<div class="content_4">
										<div class="content_4_1">250</div>
										<div class="content_4_2">MXN / Month</div>
									</div>
									<div class="content_5" @click="buyClick(250)">Buy Now</div>
								</div>
								<div class="fox2">
									<div class="content_0">Intermediate</div>
									<div class="content_1">Intermediate Plan</div>
									<div class="content_2">Designed for scaling AI professionals requiring diverse data types and enhanced precision.</div>
									<div class="content_3_row">
									<div class="content_3">
										<div class="content_3_1"><div class="content_3_1_1"></div></div>
										<div class="content_3_2">
											<div class="content_3_2_1">Multi-Modal Support:</div>
											<div class="content_3_2_2">Full acquisition and labeling services for Voice, Video, and Language</div>
										</div>
									</div>
									
									<div class="content_3">
										<div class="content_3_1"><div class="content_3_1_1"></div></div>
										<div class="content_3_2">
											<div class="content_3_2_1">Enhanced 98% Accuracy:</div>
											<div class="content_3_2_2">Advanced verification protocols with cross-validation from senior annotators for complex algorithms.</div>
										</div>
									</div>
									
									<div class="content_3">
										<div class="content_3_1"><div class="content_3_1_1"></div></div>
										<div class="content_3_2">
											<div class="content_3_2_1">Localized Strategy:</div>
											<div class="content_3_2_2">Access to culturally specific data management and priority project coordination for faster delivery.</div>
										</div>
									</div>
									</div>
									<div class="content_4">
										<div class="content_4_1">600</div>
										<div class="content_4_2">MXN / Month</div>
									</div>
									<div class="content_5" @click="buyClick(600)">Buy Now</div>
								</div>
								<div class="fox3">
									<div class="content_0">Pro</div>
									<div class="content_1">Pro Plan</div>
									<div class="content_2">The Pro level solution is suitable for individuals requiring maximum security and elite-level precision.</div>
									<div class="content_3_row">
									<div class="content_3">
										<div class="content_3_1"><div class="content_3_1_1"></div></div>
										<div class="content_3_2">
											<div class="content_3_2_1">Triple-Check Inspection:</div>
											<div class="content_3_2_2">Our most rigorous audit workflow, guaranteeing a 8% qualified rate for mission-critical applications.</div>
										</div>
									</div>
									
									<div class="content_3">
										<div class="content_3_1"><div class="content_3_1_1"></div></div>
										<div class="content_3_2">
											<div class="content_3_2_1">Privatized Deployment:</div>
											<div class="content_3_2_2">Custom installation of our data annotation system directly onto your private servers for maximum security.</div>
										</div>
									</div>
									
									<div class="content_3">
										<div class="content_3_1"><div class="content_3_1_1"></div></div>
										<div class="content_3_2">
											<div class="content_3_2_1">Dedicated Managed Workforce:</div>
											<div class="content_3_2_2">A fully managed, professional data team assigned exclusively to your organization with 24/7 oversight.</div>
										</div>
									</div>
									</div>
									<div class="content_4">
										<div class="content_4_1">2100</div>
										<div class="content_4_2">MXN / Month</div>
									</div>
									<div class="content_5" @click="buyClick(2100)">Buy Now</div>
								</div>
							</div>
						</div>
				</Modal>
				<!-- 订单弹窗 -->
				<Modal v-model="orderModalOpen" width="720px" class-name="chooseModal" footer-hide>
				    <div class="orderModal">
							<div class="title_row">
								<div class="title_1">Order Summary</div>
							</div>
							<div class="order_1">
								<div class="order_1_1">Total amount</div>
								<div class="order_1_2">{{amountText}} MXN</div>
							</div>
							<div class="order_2"></div>
							<div class="order_3">Select Payment Methods</div>
							<div class="order_4" @click="openTips">
								<div class="order_4_1"> <img src="../../assets/order_1.png"/></div>
								<div class="order_4_2">SPEI</div>
								<div  class="order_4_3"><Icon type="ios-arrow-forward" size="24"/></div>
							</div>
							<div class="order_4" @click="openTips">
								<div class="order_4_1"> <img src="../../assets/order_2.png"/></div>
								<div class="order_4_2">OXXO</div>
								<div  class="order_4_3"><Icon type="ios-arrow-forward" size="24"/></div>
							</div>
							<div class="order_4" @click="openTips">
								<div class="order_4_1"> <img src="../../assets/order_3.png"/></div>
								<div class="order_4_2">Cards (coming soon)</div>
								<div  class="order_4_3"><Icon type="ios-arrow-forward" size="24"/></div>
							</div>
							<!-- <div class="order_5" @click="openTips">
								Continue
							</div> -->
						</div>
				    
				</Modal>
	</div>
</template>

<script>
	import Header from '../../components/header'
import { WOW } from 'wowjs'
import { Message } from 'element-ui';
export default {
  data () {
    return {
      chileModal:false,
      peruModal:false,
      chooseModalOpen:false,
      orderModalOpen:false,
      type:'1',
      method:'',
      peruType:'1',
      peruMethod:'',
      amountText:'',

    }
  },
	components:{
	    Header
	},
  methods:{
		buyClick(e){
			this.amountText = e
			this.orderModalOpen = true
		},
		handleOpenModal() {
		      this.chooseModalOpen = true
		    },
		goUserAgreement(){
		    this.$router.push('/userAgreement')
		    window.scrollTo(0, 0)
		},
		goPrivacyPolicy(){
		    this.$router.push('/privacyPolicy')
		    window.scrollTo(0, 0)
		},
      openChile(){
          this.chileModal = true
          this.type='1'
          this.method = ''
      },
      openPeru(){
          this.peruModal = true
          this.peruType='1'
          this.peruMethod = ''
      },
      openTips(){
          Message.success({message:'Stay Tuned'})
      }
  },
  mounted () {
		
				
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      const wow = new WOW({
        live: false
      })
      wow.init()
    })
  }
}
</script>

<style lang="less" scoped>
	.title_row{
		text-align: center;
	}
	.title_1{
		margin-top: 20px;
		font-family: Inter, Inter;
		font-weight: 800;
		font-size: 34px;
		color: #101828;
		line-height: 41px;
	}
	.title_2{
		margin-top: 6px;
		font-family: Inter, Inter;
		font-weight: 400;
		font-size: 16px;
		color: #667085;
		line-height: 20px;
	}
	.fox_row{
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 620px;
		margin-top: 50px;
		margin-bottom: 20px;
	}
	.fox1{
		width: 320px;
		height: 580px;
		background: #F6F7F9;
		border-radius: 18px;
		border: 1px solid #E4E7EC;
		text-align: left;
		padding: 30px;
	}
	.fox1:hover{
		
		height: 600px;
		background: #F0F6FF;
		border-radius: 20px;
		border: 2px solid #1F7ED8;
		
		.content_0{
			margin-top: 10px;
		}
		.content_1{
			font-family: Inter, Inter;
			font-weight: bold;
			font-size: 28px;
			color: #101828;
			line-height: 20px;
		}
		// .content_2{
		// 	font-family: Inter, Inter;
		// 	font-weight: 800;
		// 	font-size: 48px;
		// 	color: #101828;
		// 	line-height: 59px;
		// }
		// .content_3{
		// 	font-family: Inter, Inter;
		// 	font-weight: 400;
		// 	font-size: 16px;
		// 	color: #667085;
		// 	line-height: 20px;
		// }
		// .content_4{
		// 	font-family: Inter, Inter;
		// 	font-weight: 400;
		// 	font-size: 13px;
		// 	color: #667085;
		// 	line-height: 16px;
		// }
		// .content_5{
		// 	margin-top: 57px;
		// }
	}
	.fox2{
		width: 320px;
		height: 580px;
		background: #F6F7F9;
		border-radius: 18px;
		border: 1px solid #E4E7EC;
		text-align: left;
		padding: 30px;
		margin-left: 40px;
	}
	.fox2:hover{
		
		height: 600px;
		background: #F0F6FF;
		border-radius: 20px;
		border: 2px solid #1F7ED8;
		
		.content_0{
			margin-top: 10px;
		}
		.content_1{
			font-family: Inter, Inter;
			font-weight: bold;
			font-size: 28px;
			color: #101828;
			line-height: 20px;
		}
	}
	.fox3{
		width: 320px;
		height: 580px;
		background: #F6F7F9;
		border-radius: 18px;
		border: 1px solid #E4E7EC;
		text-align: left;
		padding: 30px;
		margin-left: 40px;
	}
	.fox3:hover{
		
		height: 600px;
		background: #F0F6FF;
		border-radius: 20px;
		border: 2px solid #1F7ED8;
		
		.content_0{
			margin-top: 10px;
		}
		.content_1{
			font-family: Inter, Inter;
			font-weight: bold;
			font-size: 28px;
			color: #101828;
			line-height: 20px;
		}
	}
	.content_0{
		font-family: Inter, Inter;
		font-weight: bold;
		font-size: 14px;
		color: #1F7ED8;
		line-height: 16px;
	}
	.content_1{
		margin-top: 10px;
		font-family: Inter, Inter;
		font-weight: bold;
		font-size: 28px;
		color: #101828;
		line-height: 20px;
	}
	.content_2{
		margin-top: 10px;
		font-family: Inter, Inter;
		font-weight: 400;
		font-size: 12px;
		color: #667085;
		line-height: 16px;
	}
	.content_3_row{
		min-height: 240px;
	}
	.content_3{
		display: flex;
		margin-top: 16px;
	}
	.content_3_1{
		min-width: 18px;
	}
	.content_3_1_1{
		margin-top: 4px;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background: #17C3A5;
		border: 1px solid #17C3A5;
	}
	.content_3_2_1{
		font-family: Inter, Inter;
		font-weight: 600;
		font-size: 14px;
		color: #344054;
		line-height: 17px;
	}
	.content_3_2_2{
		margin-top: 4px;
		font-family: Inter, Inter;
		font-weight: 400;
		font-size: 12px;
		color: #667085;
		line-height: 16px;
	}
	.content_4{
		display: flex;
		margin-top: 26px;
		align-items: end;
	}
	.content_4_1{
		font-family: Inter, Inter;
		font-weight: 800;
		font-size: 36px;
		color: #101828;
	}
	.content_4_2{
		font-family: Inter, Inter;
		font-weight: bold;
		font-size: 16px;
		color: #667085;
		padding-bottom: 6px;
		margin-left: 2px;
	}
	.content_5{
		width: 236px;
		height: 48px;
		background: #1F7ED8;
		border-radius: 23px;
		font-family: Inter, Inter;
		font-weight: 600;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 14px;
		padding-top: 16px;
		margin-left: 2px;
		margin-top: 25px;
		cursor: pointer;
		text-align: center;
	}
	.orderModal{
		padding-left: 62px;
		padding-right: 62px;
	}
	.order_1{
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 27px;
	}
	.order_1_1{
		font-family: Inter, Inter;
		font-weight: bold;
		font-size: 16px;
		color: #344054;
		line-height: 20px;
	}
	.order_1_2{
		font-family: Inter, Inter;
		font-weight: 800;
		font-size: 36px;
		color: #1F7ED8;
		line-height: 44px;
	}
	.order_2{
		margin-top: 20px;
		width: 100%;
		height: 1px;
		border: 1px solid #B4B3B3;
	}
	.order_3{
		margin-top: 23px;
		font-family: Inter, Inter;
		font-weight: 800;
		font-size: 22px;
		color: #101828;
		line-height: 26px;
	}
	.order_4{
		display: flex;
		position: relative;
		width: 100%;
		height: 70px;
		background: #F6F7F9;
		border-radius: 14px;
		border: 1px solid #E4E7EC;
		align-items: center;
		margin-top: 24px;
		margin-bottom: 20px;
		cursor: pointer;
	}
	.order_4:hover{
		border: 1px solid #1F7ED8;
	}
	.order_4_1{
		margin-left: 20px;
	}
	.order_4_2{
		margin-left: 26px;
		font-family: Inter, Inter;
		font-weight: 500;
		font-size: 18px;
		color: #101828;
		line-height: 21px;
	}
	.order_4_3{
		position: absolute;
		right: 22px;
	}
	.order_5{
		width: 180px;
		height: 48px;
		background: #1F7ED8;
		border-radius: 12px;
		font-family: Inter, Inter;
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 20px;
		text-align: center;
		padding-top: 14px;
		margin-top: 32px;
		margin-left: auto;
		  margin-right: 0;
			cursor: pointer;
	}
@media all and (min-width:1440px){
    .index{
        position: relative;
        width: 100%;
        min-width: 1750px;
        .top{
            min-width: 1172px;
            padding: 20px 232px;
            background: url('../../assets/background.png') no-repeat;
            border-radius: 0px 0px 100px 100px;
            background-size: 100% 100%;
            .header{
                width: 1368px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                .left{
                    font-size: 30px;
                    font-family: Montserrat-Bold, Montserrat;
                    font-weight: bold;
                    color: #FFFFFF;
                    line-height: 48px;
                    margin-left:0px
                }
            }
            .content{
                width: 1368px;
                margin: 0 auto;
                padding: 296px 0 338px 0;
                .title1{
                    font-size: 72px;
                    font-family: Montserrat, Montserrat;
                    font-weight: bold;
                    color: #FFFFFF;
                    line-height: 84px;
                    padding-bottom: 31px;
                }
                .content_font{
                    font-size: 20px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 32px;
                }
            }
        }
        .about{
            padding: 160px 232px;
            .content{
                width: 1368px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                .point{
                    position: absolute;
                    right: -143px;
                    top: 193px;
                }
            }
            .left{
                font-size: 18px;
                font-family: Montserrat, Montserrat;
                font-weight: 400;
                color: #333333;
                line-height: 32px;
                width: 448px;
                .title{
                    font-size: 28px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #71D2FF;
                    line-height: 32px;
                }
                .title1{
                    font-size: 56px;
                    font-family: Montserrat, Montserrat;
                    font-weight: bold;
                    color: #008DFF;
                    line-height: 56px;
                    padding: 25px 0 32px 0;
                }
            }
        }
        .service{
            min-width: 1368px;
            background: #F7F7F7;
            border-radius: 100px 0px 0px 0px;
            padding: 71px 232px 98px 232px;
            .header{
                width: 1368px;
                margin: 0 auto;
                font-size: 18px;
                font-family: Montserrat-Regular, Montserrat;
                font-weight: 400;
                color: #333333;
                line-height: 32px;
								text-align: center;
                // display: flex;
                // justify-content: space-between;
                padding-bottom: 74px;
                .left{
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    .title{
                        font-size: 24px;
                        font-family: Montserrat-Light, Montserrat;
                        font-weight: 300;
                        color: #6071EC;
                        line-height: 32px;
                    }
                    .title1{
                        font-size: 56px;
                        font-family: Montserrat-Bold, Montserrat;
                        font-weight: bold;
                        color: #008DFF;
                        line-height: 56px;
                        margin-top: 22px;
                    }
                }
                .right{
									margin-top: 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
										font-family: Montserrat, Montserrat;
										font-weight: 400;
										font-size: 18px;
										color: #000000;
                }
            }
            .introduction{
                width: 1368px;
                margin: 0 auto;
                
                .left{
                    div{
                        margin: 127px 0;
                    }
                }
                .right{
                    position: relative;
                    font-size: 22px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #333333;
                    line-height: 32px;
										.right_row{
											width: 1368px;
											 margin: 0 auto;
											display: flex;
											justify-content: space-between;
											.item{
											    position: relative;
											    align-items: center;
											    width: 374px;
											    height: 420px;
											    background: #FFFFFF;
											    box-shadow: 20px 20px 40px 0px rgba(0,0,0,0.1);
											    border-radius: 16px;
											    margin-bottom: 69px;
											    padding: 0 48px;
											    z-index:999;
													text-align: center;
													.item_img{
														width: 40px;
														height: 40px;
														margin-top: 45px;
														margin-left: 114px;
													}
													.item_text{
														margin-top: 24px;
														font-family: Montserrat, Montserrat;
														font-weight: 400;
														font-size: 22px;
														color: #000000;
														line-height: 34px;
													}
											}
										}
                    
                    .point{
                        position: absolute;
                        right: -47px;
                        top: 47px;
                        z-index:1;
                    }
                    .priceBtn{
                        margin-top: 100px;
                        display: flex;
                        justify-content: right;
                        font-size: 43px;
                        font-family: Montserrat-Bold, Montserrat;
                        font-weight: bold;
                        color: #6374EC;
                        line-height: 43px;
                        .btn{
                            cursor: pointer;
                        }
                        img{
                            vertical-align: -10px;
                            margin-right: 20px;
                        }
                    }
                }
            }
        }
        .our{
            padding: 160px 232px;
						.title{
							text-align: center;
							margin-bottom: 50px;
						    .title_font{
									width: 1368px;
						       font-family: Montserrat, Montserrat;
						       font-weight: bold;
						       font-size: 56px;
						       color: #333333;
						       line-height: 56px;
						    }
						    .point{
						        position: absolute;
						        right: 0px;
						        top: 127px;
						    }
						}
            .content{
                width: 1368px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .item{
                    width: 374px;
                    height: 200px;
                    background: #008DFF;
                    box-shadow: 20px 20px 40px 0px rgba(0,0,0,0.1);
                    border-radius: 16px;
                    font-size: 24px;
                    font-family: Montserrat-SemiBold, Montserrat;
                    font-weight: 600;
                    color: #FFFFFF;
                    line-height: 32px;
                    padding: 68px 165px;
                    position: relative;
                    img{
                        position: absolute;
                        right: 232px;
                        bottom: 62px;
                    }
                }
                
            }
        }
        .footer{
            min-width: 1368px;
            border-radius: 100px 100px 0px 0px;
            padding: 71px 232px 166px 232px;
            background-color: #F7F7F7;
            .content{
                width: 1368px;
                margin: 0 auto;
                font-size: 24px;
                font-family: Montserrat-Light, Montserrat;
                font-weight: 300;
                color: #6AFFEE;
                line-height: 32px;
                .title{
                    font-family: Montserrat, Montserrat;
                    font-weight: bold;
                    font-size: 56px;
                    color: #008DFF;
                    line-height: 56px;
                    margin-top:18px;
                    margin-bottom:87px;
										text-align: center;
                }
                .sence{
                    display: flex;
                    justify-content: space-around;
                    .item{
                        width: 370px;
                        height: 442px;
                        background: #ffffff;
                        border-radius: 16px;
                        padding: 16px;
                        .item_title{
                            font-family: Montserrat, Montserrat;
                            font-weight: bold;
                            font-size: 24px;
                            color: #00DFBD;
                            margin-left: 32px;
                            margin-top: 12px;
                        }
                        .item_content{
                            font-family: Montserrat, Montserrat;
                            font-weight: 300;
                            font-size: 18px;
                            color: #333333;
                            line-height: 32px;
                            margin-left: 32px;
                            margin-top: 12px;
                        }
                    }
                }
            }
        }
				.copyright{
					width: 100%;
					// min-width: 1750px;
					background-color: #071922;
					height: 380px;
					color: #FFFFFF;
					padding-left: 140px;
					padding-top: 90px;
					.title{
						font-family: Montserrat, Montserrat;
						font-weight: bold;
						font-size: 36px;
						color: #FFFFFF;
						line-height: 56px;
					}
					.email{
						font-family: Montserrat, Montserrat;
						font-weight: 400;
						font-size: 16px;
						color: #FFFFFF;
						line-height: 34px;
						margin-top: 24px;
					}
					.time{
						font-family: Montserrat, Montserrat;
						font-weight: 400;
						font-size: 16px;
						color: #FFFFFF;
						line-height: 34px;
					}
				}
    }
}
@media all and (max-width:1440px){
    .index{
        position: relative;
        width: 100%;
        min-width: 1440px;
        .top{
            min-width: 1072px;
            padding: 20px 134px;
            background: url('../../assets/background.png') no-repeat;
            border-radius: 0px 0px 100px 100px;
            background-size: 100% 100%;
            .header{
                width: 1082px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                .left{
                    font-size: 30px;
                    font-family: Montserrat-Bold, Montserrat;
                    font-weight: bold;
                    color: #FFFFFF;
                    line-height: 48px;
                    margin-left:0px
                }
            }
            .content{
                width: 1172px;
                margin: 0 auto;
                padding: 296px 0 338px 0;
                .title1{
                    font-size: 72px;
                    font-family: Montserrat, Montserrat;
                    font-weight: bold;
                    color: #FFFFFF;
                    line-height: 84px;
                    padding-bottom: 31px;
                }
                .content_font{
                    font-size: 20px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 32px;
                }
            }
        }
        .about{
            padding: 160px 134px;
            .content{
                width: 1172px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                .point{
                    position: absolute;
                    right: -43px;
                    top: 193px;
                }
            }
            .left{
                font-size: 18px;
                font-family: Montserrat-Regular, Montserrat;
                font-weight: 400;
                color: #333333;
                line-height: 32px;
                width: 406px;
                .title{
                    font-size: 24px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #71D2FF;
                    line-height: 32px;
                }
                .title1{
                    font-size: 56px;
                    font-family: Montserrat, Montserrat;
                    font-weight: bold;
                    color: #008DFF;
                    line-height: 56px;
                    padding: 25px 0 32px 0;
                }
            }
        }
        .service{
            min-width: 1072px;
            background: #F7F7F7;
            border-radius: 100px 0px 0px 0px;
            padding: 71px 134px 98px 134px;
            .header{
                width: 1172px;
                margin: 0 auto;
                font-size: 18px;
                font-family: Montserrat-Regular, Montserrat;
                font-weight: 400;
                color: #333333;
                line-height: 32px;
								text-align: center;
                // display: flex;
                // justify-content: space-between;
                padding-bottom: 74px;
                .left{
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    .title{
                        font-size: 24px;
                        font-family: Montserrat-Light, Montserrat;
                        font-weight: 300;
                        color: #6071EC;
                        line-height: 32px;
                    }
                    .title1{
                        font-size: 56px;
                        font-family: Montserrat-Bold, Montserrat;
                        font-weight: bold;
                        color: #008DFF;
                        line-height: 56px;
                        margin-top: 22px;
                    }
                }
                .right{
									margin-top: 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                }
            }
            .introduction{
                width: 1172px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                .left{
                    div{
                        margin: 127px 0;
                    }
                }
                .right{
                    font-size: 22px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #333333;
                    line-height: 32px;
                    position: relative;
                    .point{
                        position: absolute;
                        right: -43px;
                        top: 49px;
                    }
                    .right_row{
                    	width: 1206px;
                    	 margin: 0 auto;
                    	display: flex;
                    	justify-content: space-between;
                    	.item{
                    	    position: relative;
                    	    align-items: center;
                    	    width: 374px;
                    	    height: 420px;
                    	    background: #FFFFFF;
                    	    box-shadow: 20px 20px 40px 0px rgba(0,0,0,0.1);
                    	    border-radius: 16px;
                    	    margin-bottom: 69px;
                    	    padding: 0 48px;
                    	    z-index:999;
                    			text-align: center;
                    			.item_img{
                    				width: 40px;
                    				height: 40px;
                    				margin-top: 45px;
                    				margin-left: 114px;
                    			}
                    			.item_text{
                    				margin-top: 24px;
                    				font-family: Montserrat, Montserrat;
                    				font-weight: 400;
                    				font-size: 22px;
                    				color: #000000;
                    				line-height: 34px;
                    			}
                    	}
                    }
                    .priceBtn{
                        margin-top: 100px;
                        display: flex;
                        justify-content: right;
                        font-size: 43px;
                        font-family: Montserrat-Bold, Montserrat;
                        font-weight: bold;
                        color: #6374EC;
                        line-height: 43px;
                        .btn{
                            cursor: pointer;
                        }
                        img{
                            vertical-align: -10px;
                            margin-right: 20px;
                        }
                    }
                }
            }
        }
        .our{
            padding: 160px 134px;
						.title{
							text-align: center;
							margin-bottom: 50px;
						    .title_font{
									width: 1172px;
						       font-family: Montserrat, Montserrat;
						       font-weight: bold;
						       font-size: 56px;
						       color: #333333;
						       line-height: 56px;
						    }
						    .point{
						        position: absolute;
						        right: 0px;
						        top: 127px;
						    }
						}
            .content{
                width: 1172px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .item{
                    width: 374px;
                    height: 200px;
                    background: #008DFF;
                    box-shadow: 20px 20px 40px 0px rgba(0,0,0,0.1);
                    border-radius: 16px;
                    font-size: 24px;
                    font-family: Montserrat-SemiBold, Montserrat;
                    font-weight: 600;
                    color: #FFFFFF;
                    line-height: 32px;
                    padding: 68px 165px;
                    position: relative;
                    img{
                        position: absolute;
                        right: 232px;
                        bottom: 62px;
                    }
                }
                // .title{
                //     width: 272px;
                //     height: 300px;
                //     font-size: 24px;
                //     font-family: Montserrat-Regular, Montserrat;
                //     font-weight: 400;
                //     color: #6374EC;
                //     line-height: 32px;
                //     margin-left: 50px;
                //     position: relative;
                //     .point{
                //         position: absolute;
                //         right: 0px;
                //         top: 129px;
                //     }
                //     .title_font{
                //         font-size: 56px;
                //         font-family: Montserrat-Bold, Montserrat;
                //         font-weight: bold;
                //         color: #333333;
                //         line-height: 64px;
                //     }
                // }
            }
        }
        .footer{
            min-width: 1072px;
            border-radius: 100px 100px 0px 0px;
            padding: 71px 134px 166px 134px;
            background-color: #F7F7F7;
            .content{
                width: 1172px;
                margin: 0 auto;
                font-size: 24px;
                font-family: Montserrat-Light, Montserrat;
                font-weight: 300;
                color: #6AFFEE;
                line-height: 32px;
                .title{
                    font-family: Montserrat, Montserrat;
                    font-weight: bold;
                    font-size: 56px;
                    color: #008DFF;
                    line-height: 56px;
                    margin-top:18px;
                    margin-bottom:87px;
                    text-align: center;
                }
                .sence{
                    display: flex;
                    justify-content: space-around;
                    .item{
                        width: 370px;
                        height: 442px;
                        background: #ffffff;
                        border-radius: 16px;
                        padding: 16px;
                        .item_title{
                            font-family: Montserrat, Montserrat;
                            font-weight: bold;
                            font-size: 24px;
                            color: #00DFBD;
                            margin-left: 32px;
                            margin-top: 12px;
                        }
                        .item_content{
                            font-family: Montserrat, Montserrat;
                            font-weight: 300;
                            font-size: 18px;
                            color: #333333;
                            line-height: 32px;
                            margin-left: 32px;
                            margin-top: 12px;
                        }
                    }
                }
            }
        }
				.copyright{
					width: 100%;
					// min-width: 1750px;
					background-color: #071922;
					height: 380px;
					color: #FFFFFF;
					padding-left: 140px;
					padding-top: 90px;
					.title{
						font-family: Montserrat, Montserrat;
						font-weight: bold;
						font-size: 36px;
						color: #FFFFFF;
						line-height: 56px;
					}
					.email{
						font-family: Montserrat, Montserrat;
						font-weight: 400;
						font-size: 16px;
						color: #FFFFFF;
						line-height: 34px;
						margin-top: 24px;
					}
					.time{
						font-family: Montserrat, Montserrat;
						font-weight: 400;
						font-size: 16px;
						color: #FFFFFF;
						line-height: 34px;
					}
				}
    }
}
.modalTitle{
    font-size: 28px;
    font-family: Montserrat-Bold, Montserrat;
    font-weight: bold;
    color: #333333;
    line-height: 28px;
    height: 28px;
}
.modalBody{
    .title{
        font-size: 20px;
        font-family: Montserrat-SemiBold, Montserrat;
        font-weight: 600;
        color: #333333;
        line-height: 29px;
        margin-bottom: 16px;
    }
}

</style>
<style lang="less">
.ivu-modal-content{
    border-radius: 10px!important;
}
.ivu-modal-header{
    padding: 28px!important;
}
.ivu-modal-body{
    padding: 28px!important;
}
.ivu-modal-footer{
    text-align: left!important;
    padding: 28px!important;
    padding-top: 16px!important;
    font-size: 20px!important;
    font-family: Montserrat-Medium, Montserrat!important;
    font-weight: 500!important;
    color: #FA8218!important;
}
.ivu-modal-close{
    top:20px!important;
    right: 20px!important;
}
.ivu-modal-close .ivu-icon-ios-close{
    font-size: 40px!important;
}
.ivu-radio-group-button{
    width:100%!important;
    display: flex!important;
    justify-content: space-between!important;
}
.ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{
    width: 49%!important;
    border: 2px solid #E3E8EF!important;
    border-radius: 8px!important;
    text-align: center!important;
    font-size: 20px!important;
    font-family: Montserrat-SemiBold, Montserrat;
    font-weight: 600!important;
    color: #677489;
    height: 60px!important;
    line-height: 60px!important;
    letter-spacing: 1px!important;
}
.ivu-radio-group-button .ivu-radio-wrapper:after, .ivu-radio-group-button .ivu-radio-wrapper:before{
    display: none!important;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked{
    background-color: #6374EC!important;
    color: #FFFFFF !important;
    box-shadow:0 0 0 0!important;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus:first-child{
    box-shadow:0 0 0 0!important;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus{
    box-shadow:0 0 0 0!important;
}
.methodItem{
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{
        width:100% !important;
        text-align:left !important;
        border-radius:8px !important;
        padding-left: 60px!important;
        background-repeat: no-repeat!important;
        background-position-x: 20px!important;
        background-position-y: 14px;
    }
    .right{
        float: right;
        margin-top: 17px;
    }
}
.icon1{
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{
        background-image: url('../../assets/bank_b.png');
    }
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper-checked{
        background-image: url('../../assets/bank_w.png') !important;
    }
}
.icon2{
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{
        background-image: url('../../assets/card_b.png');
    }
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper-checked{
        background-image: url('../../assets/card_w.png') !important;
    }
}
.icon3{
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{
        background-image: url('../../assets/credit_b.png');
    }
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper-checked{
        background-image: url('../../assets/credit_w.png') !important;
    }
}
.icon4{
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{
        background-image: url('../../assets/cash_b.png');
    }
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper-checked{
        background-image: url('../../assets/cash_w.png') !important;
    }
}
.vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    
    .ivu-modal {
        // top: -20px;
    }
}
.chooseModal{
	.ivu-modal {
	    top: 150px;
	}
}
.orderModal{
	
}
.el-message{
    min-width: 480px !important;
    padding: 20px 20px 20px 25px !important;
}
</style>


// WEBPACK FOOTER //
// src/page/index/index.vue